/**
 * The text of a caught value: `error.message` for an `Error`, otherwise the
 * value stringified — so a log field or error column is always a string,
 * whatever was thrown.
 *
 * Example:
 * ```ts
 * } catch (error) {
 *   logger.error("sync.failed", { error: errorMessageOf(error) });
 * }
 * ```
 */
export function errorMessageOf(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
